export default __webpack_public_path__ + "c72c72b70c82b1f4bacfb95940cb2345.woff2";